import { classMerge } from '@components/utilities/classMerge'
import type { ChangeEventHandler, Ref } from 'react'
import { inputBorderStyles } from '..'

export default function TextArea({
  ariaLabel,
  autoFocus = false,
  className,
  customRef,
  disabled = false,
  error,
  maxLength,
  onChange,
  placeholder,
  readOnly = false,
  showSuccessWithValidValue = false,
  tabIndex,
  value,
}: {
  ariaLabel?: string
  autoFocus?: boolean
  className?: string
  customRef?: Ref<HTMLTextAreaElement>
  disabled?: boolean
  error?: boolean
  maxLength?: number
  onChange?: ChangeEventHandler<HTMLTextAreaElement>
  placeholder?: string
  readOnly?: boolean
  showSuccessWithValidValue?: boolean
  tabIndex?: number
  value?: string | number | readonly string[]
}) {
  const textAreaClassName = classMerge(
    'py-4',
    'px-4',
    'rounded-lg',
    inputBorderStyles(value, error, showSuccessWithValidValue, readOnly),
    className,
  )

  return (
    <textarea
      aria-label={ariaLabel}
      autoFocus={autoFocus}
      className={textAreaClassName}
      disabled={disabled}
      maxLength={maxLength}
      onChange={onChange}
      placeholder={placeholder}
      readOnly={readOnly}
      ref={customRef}
      tabIndex={tabIndex}
      value={value}
    />
  )
}
